export default __webpack_public_path__ + "static/media/1005.70c53171.png";